module.exports = __webpack_public_path__ + "media/images/simple_search-423ef0ff371213e6a8e77c1d13b42329.png";